import SelectButton from '/react4xp/components/prototype/SelectButton'

import type { SubpageHeroProps } from './types'

export default function SubpageHero({ overline, heading, filters = [] }: SubpageHeroProps) {
	return (
		<section className="bg-black-950">
			<div className="container flex flex-col gap-6 py-12">
				{overline && <p className="body uppercase text-brand-500">{overline}</p>}
				<h1 className="text-[2.5rem] md:text-5xl leading-[1.15] font-medium text-pure-white max-w-200">{heading}</h1>
			</div>

			{filters.length > 0 && (
				<div className="container flex flex-wrap gap-6 pb-8">
					{filters.map((filter) => (
						<SelectButton
							key={filter.id}
							label={filter.label}
							options={filter.options}
							value={filter.options.find((option) => option.value === filter.value)}
							onChange={(option) => filter.onChange(option.value)}
							className="min-w-40"
						/>
					))}
				</div>
			)}
		</section>
	)
}
